import React from 'react';
import { MessageBar, MessageBarType } from '@fluentui/react';

interface ISuccessMessageComponentProps {
    message: string;
    isHtml?: boolean;
};

const SuccessMessageComponent = (props: ISuccessMessageComponentProps) => {
    return (
        (props.message !== '') ? (
            <MessageBar 
                messageBarType={MessageBarType.success}
                styles={{
                    root: {
                        marginTop: '10px',
                        marginBottom: '10px',
                    },
                }}>
                {
                    props.isHtml ? (
                        <div dangerouslySetInnerHTML={{ __html: props.message }} />
                    ) : (
                        props.message
                    )
                }
            </MessageBar>
        ) : (
             null
        )
    );
};

export default SuccessMessageComponent;
